import { useEffect, useState } from 'react'

export function useOrientation() {
  const [orientation, setOrientation] = useState<'portrait' | 'landscape' | undefined>('portrait')

  function handleOrientationChange(mediaQuery: any) {
    if (mediaQuery.matches) {
      setOrientation('landscape')
    } else {
      setOrientation('portrait')
    }
  }

  useEffect(() => {
    const landscapeQuery = window.matchMedia('(orientation: landscape)')
    landscapeQuery.addEventListener('change', handleOrientationChange)
    return () => {
      landscapeQuery.removeEventListener('change', handleOrientationChange)
    }
  }, [])

  return orientation
}
